import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import NavHotel from './NavHotel';
import user from '../assets/images/default.png';
import croix from "../assets/images/close.png";
import back from "../assets/images/back.png";
import MenuHeader from './MenuHeader';
import TherapistService from '../services/therapist.service';
import useApi from '../hooks/useApi';
import Modal from "react-modal";
import DateTimeSelector from './DateTimeSelector';
import HeaderTherapist from './HeaderTherapist';
import ReviewList from './ReviewList';
import Informations from './Informations';
import { useNotifications } from '../context/NotificationProvider';
import useAuth from '../hooks/useAuth';
import UserService from '../services/user.service';
import CalendarManagementService from '../services/calendar_management.service';
import GeneralSettingService from '../services/general_setting.service';
import { useTranslation } from 'react-i18next';
import { usePrompt } from '../hooks/usePrompt';
import AvailableSlotsService from '../services/available_slots.service';
import CalendarService from '../services/calendar.service';
import { IconButton, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info'
import { bindEvent, getPusher, initPusher } from "../services/pusher.service";
import { hasAnyBookableSlot, mapWithConcurrency, normalizeAvailabilityDate, toDisplayDateString, uniqueAvailabilityDates } from '../utils/availability';
import FlyproCardMetadata from './FlyproCardMetadata';


const customStyles = {
  content: {
    width: "33%",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

const customStyles2 = {
  content: {
    width: "33%",
    top: "50%",
    padding: "0px",
    left: "50%",
    right: "auto",
    bottom: "auto",
    borderRadius: "0px",
    boxShadow: "none",
    maxWidth: "450px",
    margin: "auto",
    textAlign: "center",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

const EDIT_STEP_PATHS = [
  '/choose-location',
  '/hotel-choose-service',
  '/hotel-choose-therapist',
  '/hotel-payment'
];

Modal.setAppElement("#root");

function ChooseHotelTherapist() {
  const { t, i18n } = useTranslation(['hotel', 'therapist']);

  const { auth } = useAuth();
  const loc = useLocation();
  const navState = loc.state || {};
  const sessionState = JSON.parse(sessionStorage.getItem('state') || '{}');

  const [therapists, setTherapists] = useState([]);
  const [therapistsOther, setTherapistOther] = useState('');
  const [currentTherapist, setCurrentTherapist] = useState('');
  const [modalIsOpen, setIsOpen] = useState(false);
  const [hours, setHours] = useState('');
  const [modalIsOpen2, setIsOpen2] = useState(false);
  const [previousSelection, setPreviousSelection] = useState({ date: null, time: null });
  const [firstOpen2, setIsFirstOpen2] = useState(false);
  const [selectedDateScroll, setSelectedDateScroll] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(() => {
    if (sessionState.selectedDate) {
      return new Date(sessionState.selectedDate);
    }
    return null;
  });
  const [selectedTime, setSelectedTime] = useState(sessionState.selectedTime || sessionState.time || null);
  const [filter, setFilter] = useState(null)
  const [visibleDays, setVisibleDaysCount] = useState(10);
  const [unavailableDates, setUnavailableDates] = useState([]);
  const [availableHours, setAvailableHours] = useState([]);
  const [buffertime, setBufferTime] = useState([]);
  const [hasAutoSelected, setHasAutoSelected] = useState(false);
  const [allTherapistsList, setAllTherapistsList] = useState([]); // Cache for all therapists
  const isFetchingAllTherapists = useRef(false);
  const [filters, setFilters] = useState({
    with: 'primary_address,zones,media,categories,slots',
    sort: 'firstname'
  });
  const realtimeRefreshInFlightRef = useRef(false);
  const realtimeLastRefreshRef = useRef(0);
  const refreshAvailabilityRef = useRef(null);
  const location = useLocation();
  const addressObj = navState.address ?? sessionState.address ?? {};
  const duo = navState.duo ?? sessionState.duo;
  const rawSelectedServices = useMemo(() =>
    navState.products ?? sessionState.products ?? sessionState.selectedServices ?? [],
    [navState.products, sessionState.products, sessionState.selectedServices]
  );

  const selectedServices = useMemo(() => {
    return Array.isArray(rawSelectedServices)
      ? rawSelectedServices.map(s => {
        const product = s?.product ?? s?.service ?? s;
        const productId = s?.productId ?? product?.id ?? s?.id ?? null;
        const duration = Number(s?.duration ?? product?.duration ?? s?.product?.duration ?? s?.service?.duration ?? 0) || 0;
        const price = Number(s?.price ?? product?.price ?? s?.product?.price ?? 0) || 0;
        const categoryId = s?.category_id ?? s?.category?.id ?? product?.category_id ?? product?.category?.id ?? null;
        return { productId, product, duration, price, categoryId };
      }).filter(Boolean)
      : [];
  }, [rawSelectedServices]);

  const selectedProductIds = useMemo(() => {
    return selectedServices.map(service => service.productId).filter(Boolean);
  }, [selectedServices]);

  const isActive = useMemo(() => navState.isActive ?? sessionState.isActive, [navState.isActive, sessionState.isActive]);
  const hotel = useMemo(() => navState.hotel ?? sessionState.hotel ?? {}, [navState.hotel, sessionState.hotel]);
  const hotelId = useMemo(() => {
    const productHotelId = selectedServices
      .map(service => service?.product?.hotel_id)
      .find(value => value !== undefined && value !== null && value !== '');

    return navState.hotelId
      ?? navState.hotel_id
      ?? sessionState.hotelId
      ?? sessionState.hotel_id
      ?? hotel?.id
      ?? addressObj?.hotel_id
      ?? addressObj?.hotel?.id
      ?? productHotelId;
  }, [
    navState.hotelId,
    navState.hotel_id,
    sessionState.hotelId,
    sessionState.hotel_id,
    hotel,
    addressObj,
    selectedServices
  ]);
  const address = useMemo(() => navState.address ?? sessionState.address, [navState.address, sessionState.address]);
  const addressValues = useMemo(() => {
    const {
      street = '',
      street_number = '',
      zip_code = '',
      city = '',
      state: stateName = '',
      country = '',
      lat,
      lng,
      latitude,
      longitude
    } = address;
    return { street, street_number, zip_code, city, stateName, country, lat, lng, latitude, longitude };
  }, [address]);

  const { street, street_number, zip_code, city, stateName, country, lat, lng, latitude, longitude } = addressValues;

  const latToUse = useMemo(() => lat ?? latitude, [lat, latitude]);
  const lngToUse = useMemo(() => lng ?? longitude, [lng, longitude]);
  const [modalIsPaiementOpen, setModalIsPaiementOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  const openModalPaiement = (message) => {
    setModalMessage(message);
    setModalIsPaiementOpen(true);
  };

  const closeModalPaiement = () => {
    setModalIsPaiementOpen(false);
  };

  const redirectToHome = () => {
    // si tu utilises react-router
    window.location.reload();
    setModalIsPaiementOpen(false);
  };

  const fetchCalendarTherapist = async (therapist, date) => {
    try {
      const response = await CalendarManagementService.index(
        {
          date: formatISODate(date),
          therapist_id: therapist.id,
          with: 'therapist.media,therapist.zones,calendars_managements_slots.slot',
        },
        api,
        auth?.accessToken ? false : true
      );
      return response



    } catch (error) {
      console.error('Erreur lors de la récupération des données du calendrier :', error);
      throw error;
    }
  };

  const oldBooking = JSON.parse(sessionStorage.getItem("oldBooking") || "{}");
  const newBooking = JSON.parse(sessionStorage.getItem("newBooking") || "{}");
  const isEdit = sessionStorage.getItem("editBookingMode") === "true";
  const prevNew = isEdit ? newBooking : {};
  const [selectedTherapist, setSelectedTherapist] = useState(() => {
    if (isEdit) {
      // First try sessionState.selectedTherapists, then newBooking.therapists
      const therapists = sessionState.selectedTherapists ||
        (Array.isArray(prevNew.therapists) ? prevNew.therapists : []);

      if (therapists.length > 0) {
        return therapists.map(therapist => ({
          id: therapist.id || therapist
        }));
      }
    }
    return [{ id: 0 }];
  });

  const notify = useNotifications();

  // Use values from sessionStorage for edit mode, otherwise calculate from services
  const sessionTotalDuration = sessionState.totalDuration;
  const sessionTotalPrice = sessionState.totalPrice;

  const totalDuration = useMemo(() => {
    if (isEdit && sessionTotalDuration) {
      return sessionTotalDuration;
    }

    if (!selectedServices || selectedServices.length === 0) return 0;

    const durations = selectedServices.map(s =>
      s?.duration ??
      s?.product?.duration ??
      s?.service?.duration ??
      0
    ).map(Number);

    if (!duo) {
      // SOLO = sequential sum
      return durations.reduce((a, b) => a + b, 0);
    }

    // DUO pairing logic
    if (durations.length === 2) {
      return Math.max(durations[0] ?? 0, durations[1] ?? 0);
    }

    if (durations.length === 4) {
      const t1 = (durations[0] ?? 0) + (durations[2] ?? 0);
      const t2 = (durations[1] ?? 0) + (durations[3] ?? 0);
      return Math.max(t1, t2);
    }

    // fallback
    const half = Math.ceil(durations.length / 2);
    const t1 = durations.slice(0, half).reduce((a, b) => a + b, 0);
    const t2 = durations.slice(half).reduce((a, b) => a + b, 0);
    return Math.max(t1, t2);
  }, [isEdit, sessionTotalDuration, selectedServices, duo]);


  const totalPrice = isEdit && sessionTotalPrice
    ? sessionTotalPrice
    : selectedServices.reduce((sum, item) => {
      const p = item.price
        ?? item.product?.price
        ?? item.service?.price
        ?? 0;
      return sum + p;
    }, 0);
  const navigate = useNavigate();
  const api = useApi();
  const [formData, setFormData] = useState({
    tags: "",
    is_asca: "",
    is_rme: "",
    civility: "",
  });

  usePrompt(
    isEdit,
    "Êtes-vous sûr de vouloir quitter la modification ? Vos changements ne seront pas enregistrés.",
    next => EDIT_STEP_PATHS.some(p => next.pathname.startsWith(p))
  );

  function formatISODate(isoDate) {
    return new Date(isoDate)
      .toLocaleDateString('en-CA', { timeZone: 'Europe/Zurich' })
      .split("T")[0];
  }

  // useEffect(() => {
  //   if (selectedDate && selectedTime && latToUse != null && lngToUse != null) {
  //     fetchTherapist(
  //       formatISODate(selectedDate),
  //       selectedTime,
  //       totalDuration,
  //       lngToUse,
  //       latToUse,
  //       zip_code,
  //       duo
  //     );
  //   }
  // }, [selectedDate, selectedTime, totalDuration, latToUse, lngToUse, zip_code, duo]);

  // After therapists are fetched, if in edit mode and preselected therapist(s) exist, set them as selected
  useEffect(() => {
    if (therapists.length > 0) {
      const isEdit = sessionStorage.getItem("editBookingMode") === "true";
      const sessionState = JSON.parse(sessionStorage.getItem('state') || '{}');
      const preselected = sessionState.selectedTherapists || sessionState.selectedTherapist;
      if (isEdit && preselected && preselected.length > 0) {
        // Only set if not already selected
        if (!selectedTherapist.length || !preselected.every(sel => selectedTherapist.some(t => t.id === (sel.id || sel)))) {
          setSelectedTherapist(preselected.map(sel => typeof sel === 'object' ? { id: sel.id } : { id: sel }));
          setHasAutoSelected(true);
        }
      } else if (!hasAutoSelected && (!selectedTherapist.length || selectedTherapist[0].id === 0)) {
        setSelectedTherapist([{ id: 0 }]);
        setHasAutoSelected(true);
      }
    }
  }, [therapists, hasAutoSelected, selectedTherapist.length]);

  const addedTherapist = useCallback((therapist) => {
    if (!selectedDate || !selectedTime)
      return;
    setSelectedTherapist((prevTherapists) => {
      if (therapist.id === 0) {
        return [therapist];
      } else {
        const updatedTherapists = prevTherapists.some(t => t.id === 0)
          ? []
          : [...prevTherapists];

        if (updatedTherapists.some(t => t.id === therapist.id)) {
          return updatedTherapists.filter(t => t.id !== therapist.id);
        }
        else if (!duo) {
          return [therapist];
        }
        else {
          if (updatedTherapists.length >= 2) {
            return updatedTherapists;
          }
          return [...updatedTherapists, therapist];
        }
      }
    });
  }, [selectedDate, selectedTime, duo]);

  useEffect(() => {
    const savedState = sessionStorage.getItem('state');
    if (savedState) {
      const parsedState = JSON.parse(savedState);

      if (parsedState.selectedDate) setSelectedDate(new Date(parsedState.selectedDate));
      if (parsedState.selectedTime) setSelectedTime(parsedState.selectedTime);
      if (parsedState.selectedTherapist) setSelectedTherapist(parsedState.selectedTherapist);
    }
  }, []);

  // useEffect(() => {
  //   if (!selectedServices || selectedServices.length === 0) {
  //     navigate('/choose-hotel-service');
  //   }
  // }, [selectedServices, address, navigate]);




  useEffect(() => {
    // const now = new Date();
    // let timeToUse = selectedTime;
    // if (!selectedTime) {
    //   const nextQuarterHour = Math.ceil(now.getMinutes() / 15) * 15;
    //   now.setMinutes(nextQuarterHour);
    //   now.setSeconds(0);
    //   timeToUse = now.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    // }

    let timeToUse = selectedTime;
    let dateToUse = selectedDate;

    if (!timeToUse) {
      const now = new Date();
      const zurichNow = new Date(now.toLocaleString("en-US", { timeZone: "Europe/Zurich" }));
      const minutes = zurichNow.getMinutes();
      const nextQuarter = Math.ceil(minutes / 15) * 15;

      if (nextQuarter === 60) {
        zurichNow.setHours(zurichNow.getHours() + 1);
        zurichNow.setMinutes(0);
      } else {
        zurichNow.setMinutes(nextQuarter);
      }
      zurichNow.setSeconds(0);
      zurichNow.setMilliseconds(0);

      timeToUse = zurichNow.toTimeString().slice(0, 5);
    }

    if (!dateToUse) {
      const now = new Date();
      const zurichDateStr = now.toLocaleString("en-US", { timeZone: "Europe/Zurich" });
      const zurichDate = new Date(zurichDateStr);
      zurichDate.setHours(0, 0, 0, 0);
      dateToUse = zurichDate;

    }
    // Always show therapists by zone and service on initial load (no selected time) for hotel bookings
    if (selectedDate && !selectedTime) {
      handleIfInvalidOrPastDate(dateToUse, null);
    }
    // Show therapists for specific time slot when time is selected
    else if (selectedDate && selectedTime && latToUse != null && lngToUse != null) {
      fetchTherapist(formatISODate(dateToUse), timeToUse, totalDuration, lngToUse, latToUse, zip_code);
    }
    else {
      handleIfInvalidOrPastDate((dateToUse), null)
    }

    if (selectedDate || selectedDateScroll) {
      updateDaysToShow(selectedDate || selectedDateScroll);
    }
  }, [selectedDate, selectedTime, totalDuration, latToUse, lngToUse, zip_code, selectedDateScroll, duo]);

  // Set today's date as default if no date is selected
  // useEffect(() => {
  //   if (!selectedDate) {
  //     setSelectedDate(new Date());
  //   }
  // }, []);

  const getInitialDaysToShow = () => {
    const maxVisibleMonths = 2;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const endExclusive = new Date(today.getFullYear(), today.getMonth() + maxVisibleMonths + 1, 1);
    const days = [];
    let cur = new Date(today);
    while (cur < endExclusive) {
      days.push(new Date(cur.getFullYear(), cur.getMonth(), cur.getDate()));
      cur.setDate(cur.getDate() + 1);
    }
    const windowSize = 9;
    return days.slice(0, windowSize);
  };

  const [daysToShow, setDaysToShow] = useState(() => getInitialDaysToShow());
  const [showPopup, setShowPopup] = useState(false);

  const updateDaysToShow = (baseDate) => {
    if (!baseDate || isNaN(baseDate.getTime())) {
      console.error('Invalid baseDate in updateDaysToShow');
      return;
    }

    const maxVisibleMonths = 2;
    const windowSize = 9;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const startAllowed = new Date(today);
    const endExclusive = new Date(today.getFullYear(), today.getMonth() + maxVisibleMonths + 1, 1);
    const allDays = [];
    let cur = new Date(startAllowed);
    while (cur < endExclusive) {
      allDays.push(new Date(cur.getFullYear(), cur.getMonth(), cur.getDate()));
      cur.setDate(cur.getDate() + 1);
    }

    const lastAllowedDate = allDays[allDays.length - 1];

    // normalize baseDate
    const anchor = new Date(baseDate);
    anchor.setHours(0, 0, 0, 0);

    // Clamp anchor into allowed range
    if (anchor < allDays[0]) anchor.setTime(allDays[0].getTime());
    if (anchor > lastAllowedDate) anchor.setTime(lastAllowedDate.getTime());

    // find index >= anchor
    let startIndex = allDays.findIndex(d => d.getTime() >= anchor.getTime());
    if (startIndex === -1) startIndex = Math.max(0, allDays.length - windowSize);

    const maxStart = Math.max(0, allDays.length - windowSize);
    const clampedStart = Math.min(startIndex, maxStart);
    const slice = allDays.slice(clampedStart, clampedStart + windowSize);
    setDaysToShow(slice);
  };

  // Effect for fetching unavailable dates when dependencies change
  const isFetchingUnavailableDates = useRef(false);
  const prevUnavailableDeps = useRef({});
  const lastUnavailableRefreshRef = useRef(0);
  const unavailableDatesRequestRef = useRef(0);
  const bookableDatesCacheRef = useRef(new Map());
  const bookableDatesInFlightRef = useRef(new Map());


  const fetchCalendarData = useCallback(async (start, end, therapist = null) => {
    try {
      const params = {
        with: 'therapist.media,therapist.zones,calendars_managements_slots.slot',
        date: `between:${start},${end}`,
      }

      if (therapist?.id) {
        params.therapist_id = therapist.id;
      }
      const [calendar_management_response] = await Promise.all([CalendarManagementService.index(
        params,
        api,
        auth?.accessToken ? false : true
      )]);
      const filteredDates = [];
      calendar_management_response.forEach(entry => {
        if (entry.date && entry.calendars_managements_slots.length > 0 && entry.calendars_managements_slots.some(slot => slot.status === 'AVAILABLE' || slot.status === 'OVER_TIME')) {
          filteredDates.push(entry.date);
        }
      });
      // console.log('filteredDates', filteredDates);


      return uniqueAvailabilityDates(filteredDates);

    } catch (error) {
      console.error('Erreur lors de la récupération des données du calendrier :', error);
      throw error;
    }
  }, [api, auth?.accessToken]);

  const fetchBookableDates = useCallback(async (start, end, therapist = null) => {
    const therapistId = therapist?.id || null;
    const isEditMode = sessionStorage.getItem("editBookingMode") === "true";
    const booking = JSON.parse(sessionStorage.getItem("newBooking"));
    const oldBooking = JSON.parse(sessionStorage.getItem("oldBooking"));
    const bookingId = isEditMode ? booking?.id ?? oldBooking?.id ?? 0 : null;
    const cacheKey = [
      start,
      end,
      therapistId || 'all',
      selectedProductIds.join(','),
      totalDuration || '',
      zip_code || '',
      latToUse ?? '',
      lngToUse ?? '',
      hotelId || '',
      duo ? 'duo' : 'solo',
      bookingId || '',
    ].join('|');

    const cached = bookableDatesCacheRef.current.get(cacheKey);
    if (cached && Date.now() - cached.timestamp < 30000) {
      return cached.dates;
    }

    const inFlight = bookableDatesInFlightRef.current.get(cacheKey);
    if (inFlight) {
      return inFlight;
    }

    const request = (async () => {
      const candidateDates = uniqueAvailabilityDates(await fetchCalendarData(start, end, therapist));

      if (!candidateDates.length) {
        return [];
      }

      if (!selectedProductIds.length || latToUse == null || lngToUse == null || !zip_code || !totalDuration || !hotelId) {
        return candidateDates;
      }

      const checks = await mapWithConcurrency(candidateDates, 3, async (candidateDate) => {
        const date = normalizeAvailabilityDate(candidateDate);
        if (!date) {
          return null;
        }

        const payload = {
          date,
          duration: totalDuration,
          lng: lngToUse,
          lat: latToUse,
          zip_code,
          products: selectedProductIds,
          is_hotel: true,
          hotel_id: hotelId,
          is_duo: duo,
        };

        if (isEditMode) {
          payload.booking_id = bookingId;
        }

        if (therapistId) {
          payload.therapists = [therapistId];
          payload.is_duo = false;
        }

        try {
          const availability = await AvailableSlotsService.store(payload, api, null, {
            loaderKey: `hotel-profile-date-availability-${date}`,
          });
          return hasAnyBookableSlot(availability) ? candidateDate : null;
        } catch (error) {
          console.error('Error validating hotel bookable date:', date, error);
          return null;
        }
      });

      const bookableDates = checks.filter(Boolean);
      bookableDatesCacheRef.current.set(cacheKey, {
        timestamp: Date.now(),
        dates: bookableDates,
      });
      return bookableDates;
    })();

    bookableDatesInFlightRef.current.set(cacheKey, request);

    try {
      return await request;
    } finally {
      bookableDatesInFlightRef.current.delete(cacheKey);
    }
  }, [api, duo, fetchCalendarData, hotelId, latToUse, lngToUse, selectedProductIds, totalDuration, zip_code]);

  const refreshUnavailableDates = useCallback(async ({ force = false } = {}) => {
    if (isFetchingUnavailableDates.current) {
      return;
    }

    const windowStart = (daysToShow && daysToShow.length)
      ? daysToShow[0]
      : (selectedDate || selectedDateScroll || new Date());
    const windowStartKey = windowStart instanceof Date
      ? windowStart.toDateString()
      : new Date(windowStart).toDateString();
    const selectedDateKey = selectedDate instanceof Date
      ? selectedDate.toDateString()
      : selectedDate
        ? new Date(selectedDate).toDateString()
        : null;
    const currentDeps = {
      windowStartKey,
      visibleDays,
      selectedDateKey,
      selectedTime: selectedTime || null,
      currentTherapistId: currentTherapist?.id || null,
      modalIsOpen2,
      selectedProductIds: selectedProductIds.join(','),
      latToUse,
      lngToUse,
      zip_code,
      totalDuration,
      hotelId,
      duo,
    };

    const depsChanged = Object.keys(currentDeps).some(
      key => prevUnavailableDeps.current[key] !== currentDeps[key]
    );

    if (!force && !depsChanged) {
      return;
    }

    const now = Date.now();
    if (force && now - lastUnavailableRefreshRef.current < 1500) {
      return;
    }

    prevUnavailableDeps.current = currentDeps;
    lastUnavailableRefreshRef.current = now;
    isFetchingUnavailableDates.current = true;

    try {
      const startDate = windowStart.toLocaleDateString('en-CA').split('T')[0];
      const endDate = new Date(startDate);
      endDate.setDate(endDate.getDate() + visibleDays + 1);
      const formattedEndDate = endDate.toLocaleDateString('en-CA').split('T')[0];

      let dates = [];

      if ((selectedDate || selectedTime) && !modalIsOpen2) {
        setPreviousSelection({ date: selectedDate, time: selectedTime });
      }
      const requestId = ++unavailableDatesRequestRef.current;

      if (currentTherapist && modalIsOpen2) {
        if (firstOpen2) {
          setSelectedDate(null);
          setSelectedTime(null);
          // setSelectedDateScroll(new Date());
          setIsFirstOpen2(false);
        }
        dates = await fetchBookableDates(startDate, formattedEndDate, currentTherapist);
      } else {
        dates = await fetchCalendarData(startDate, formattedEndDate);
      }

      if (requestId === unavailableDatesRequestRef.current) {
        const formattedDates = dates.map(toDisplayDateString).filter(Boolean);
        setUnavailableDates(formattedDates);
      }
    } catch (error) {
      console.error('Error fetching unavailable dates:', error);
    } finally {
      isFetchingUnavailableDates.current = false;
    }
  }, [
    daysToShow,
    visibleDays,
    selectedDate,
    selectedDateScroll,
    currentTherapist?.id,
    selectedTime,
    modalIsOpen2,
    firstOpen2,
    fetchBookableDates,
    selectedDateScroll,
    selectedProductIds,
    latToUse,
    lngToUse,
    zip_code,
    totalDuration,
    hotelId,
    duo,
  ]);

  useEffect(() => {
    refreshUnavailableDates();
  }, [refreshUnavailableDates]);

  // Effect for fetching available hours when dependencies change
  const isFetchingAvailableHours = useRef(false);
  const prevAvailableHoursDeps = useRef({});

  const refreshAvailableHours = useCallback(async ({ force = false } = {}) => {
    let dateToUse = selectedDate;
    if (!dateToUse) {
      const now = new Date();
      const zurichDateStr = now.toLocaleString("en-US", { timeZone: "Europe/Zurich" });
      const zurichDate = new Date(zurichDateStr);
      zurichDate.setHours(0, 0, 0, 0);
      dateToUse = zurichDate;
    }

    const currentDeps = {
      selectedProductIds: selectedProductIds.join(','),
      selectedDate: selectedDate?.toISOString(),
      latToUse,
      lngToUse,
      zip_code,
      totalDuration,
      hotelId
    };

    const depsChanged = Object.keys(currentDeps).some(key =>
      prevAvailableHoursDeps.current[key] !== currentDeps[key]
    );

    if (!force && !depsChanged) {
      return;
    }

    prevAvailableHoursDeps.current = currentDeps;

    if (isFetchingAvailableHours.current) {
      return;
    }

    isFetchingAvailableHours.current = true;

    try {
      if (!dateToUse) {
        const todayHours = getNextHourSlots(new Date());
        setHours(todayHours);
      }

      if (latToUse != null && lngToUse != null && zip_code && selectedProductIds.length && totalDuration && selectedDate) {
        const isEditMode = sessionStorage.getItem("editBookingMode") === "true";
        const booking = JSON.parse(sessionStorage.getItem("newBooking"));
        const oldBooking = JSON.parse(sessionStorage.getItem("oldBooking"));
        const payload = {
          date: dateToUse.toLocaleDateString('en-CA').split('T')[0],
          duration: totalDuration,
          lng: lngToUse,
          lat: latToUse,
          zip_code,
          products: selectedProductIds,
          is_hotel: true,
          hotel_id: hotelId,
          is_duo: duo,
        };

        if (isEditMode) {
          payload.booking_id = booking?.id ?? oldBooking?.id ?? 0;
        }

        if (currentTherapist?.id && modalIsOpen2) {
          payload.therapists = [currentTherapist.id];
          payload.is_duo = false;
        }

        const availabilities = await AvailableSlotsService.store(payload, api);
        setAvailableHours(availabilities);
      } else {
        const todayHours = getNextHourSlots(new Date());
        setHours(todayHours);
      }
    } catch (error) {
      console.error('Error fetching available hours:', error);
    } finally {
      isFetchingAvailableHours.current = false;
    }
  }, [
    selectedProductIds,
    selectedDate,
    latToUse,
    lngToUse,
    zip_code,
    totalDuration,
    hotelId,
    currentTherapist,
    modalIsOpen2,
    duo,
  ]);

  useEffect(() => {
    refreshAvailableHours();
  }, [refreshAvailableHours]);

  // Effect for fetching buffer time (only once on mount)
  useEffect(() => {
    const fetchBufferTime = async () => {
      try {
        const bufferTime = await GeneralSettingService.index('setting=in:buffer_before,buffer_after', api, auth?.accessToken ? false : true);

        const bufferBefore = bufferTime.find(item => item.setting === 'buffer_before')?.value || '0';
        const bufferAfter = bufferTime.find(item => item.setting === 'buffer_after')?.value || '0';

        setBufferTime({ bufferBefore, bufferAfter });
      } catch (error) {
        console.error('Error fetching buffer time:', error);
      }
    };

    fetchBufferTime();
  }, []);

  const isZipInZone = (zipCode, zone) => {
    if (!zone.zip_code) return false;

    const zipPatterns = zone.zip_code.split(',');

    for (const pattern of zipPatterns) {
      if (pattern.includes('-')) {
        const [start, end] = pattern.split('-').map(Number);
        const numericZip = Number(zipCode);
        if (numericZip >= start && numericZip <= end) {
          return true;
        }
      }
      else if (pattern === zipCode) {
        return true;
      }
    }

    return false;
  };

  const handleIfInvalidOrPastDate = async (date, time) => {
    const today = new Date();
    const selected = new Date(date);
    const selectedCategoryIds = selectedServices.map(service => service.categoryId).filter(Boolean);

    const noRealDate =
      !date ||
      date === '1970-01-01' ||
      isNaN(selected.getTime()) ||
      selected < new Date(today.toDateString());

    // Show therapists by zone and service for initial load or invalid dates
    if (noRealDate || !time) {
      isFetchingAllTherapists.current = true;
      try {
        const allTherapistsRaw = allTherapistsList.length > 0 ? allTherapistsList : await UserService.indexByRole(
          { ...filters, status: "ACTIVE" },
          'ROLE_FLYPRO',
          api,
          true
        );
        const allTherapists = allTherapistsRaw.sort((a, b) => {
          return (a.agent_type === "EMPLOYEE" ? -1 : 1) - (b.agent_type === "EMPLOYEE" ? -1 : 1);
        });
        setAllTherapistsList(allTherapists);
        // Filter therapists by zone
        const therapistsInZone = zip_code
          ? allTherapists.filter(therapist =>
            therapist.zones?.some(zone => {
              const zipParts = zone.zip_code.split(",");
              return zipParts.some(part => {
                const zipRange = part.split("-").map(Number);
                if (zipRange.length === 1) {
                  return zip_code == zipRange[0];
                } else {
                  const [startZip, endZip] = zipRange;
                  return zip_code >= startZip && zip_code <= endZip;
                }
              });
            })
          )
          : allTherapists;

        // Filter therapists by service categories
        const filteredTherapists = selectedCategoryIds.length > 0
          ? therapistsInZone.filter(therapist =>
            therapist.categories?.some(cat => selectedCategoryIds.includes(cat.id))
          )
          : therapistsInZone;

        setTherapists(filteredTherapists);
        setTherapistOther([]); // Hotel bookings don't show "available on other slots"

        return true; // pour indiquer que la date était invalide
      } catch (error) {
        setTherapists([]);
        setTherapistOther([]);
        return true;
      } finally {
        isFetchingAllTherapists.current = false;
      }
    }

    return false; // la date est valide
  };
  const selectedCategoryIds = useMemo(() => {
    const categoryIds = selectedServices
      .map(service => service.categoryId)
      .filter(Boolean);
    return categoryIds;
  }, [selectedServices]);

  // Single fetch for all therapists list 
  useEffect(() => {
    if (allTherapistsList.length > 0 || isFetchingAllTherapists.current) return;
    const fetchAllTherapists = async () => {
    
      isFetchingAllTherapists.current = true;
      try {
        const result = await UserService.indexByRole(
          { ...filters, status: "ACTIVE" },
          'ROLE_FLYPRO',
          api,
          true
        );
        const sorted = result.sort((a, b) => {
          return (a.agent_type === "EMPLOYEE" ? -1 : 1) - (b.agent_type === "EMPLOYEE" ? -1 : 1);
        });
        setAllTherapistsList(sorted);
      } catch (error) {
        console.error('Error fetching all therapists:', error);
        setAllTherapistsList([]);
      } finally {
        isFetchingAllTherapists.current = false;
      }
    };
    fetchAllTherapists();
  }, [api, filters]);

  // Synchronize hours state with availableHours from API
  useEffect(() => {
    if (availableHours && Array.isArray(availableHours) && availableHours.length > 0) {
      setHours(availableHours);
    }
  }, [availableHours]);


  const fetchTherapist = async (date, time, totalDuration, lngToUse, latToUse, zip_code, duo) => {

    try {
      const productIds = selectedProductIds;
      const isEditMode = sessionStorage.getItem("editBookingMode") === "true";
      const booking = JSON.parse(sessionStorage.getItem("newBooking"));
      const oldBooking = JSON.parse(sessionStorage.getItem("oldBooking"));
      const params = isEditMode ? {
        date,
        time,
        duration: totalDuration,
        lng: lngToUse,
        lat: latToUse,
        zip_code,
        is_duo: duo,
        is_hotel: true,
        status: "ACTIVE",
        hotel_id: hotelId,
        products: productIds,
        categories: selectedCategoryIds,
        booking_id: booking?.id ?? oldBooking?.id ?? 0
      } : {
        date,
        time,
        duration: totalDuration,
        lng: lngToUse,
        lat: latToUse,
        zip_code,
        is_duo: duo,
        is_hotel: true,
        status: "ACTIVE",
        hotel_id: hotelId,
        products: productIds,
        categories: selectedCategoryIds,
      };


      let therapistResponse = await TherapistService.store(params, api, {
        with: `media,categories`,
        ...formData
      },
        auth?.accessToken ? false : true
      );

      // Use cached therapists list instead of fetching again
      const allTherapists = allTherapistsList.length > 0 ? allTherapistsList : [];

      if (duo) {
        therapistResponse = [...new Set([].concat(...Object.values(therapistResponse)))];
      }

      if (therapistResponse.length === 0) {
        setTherapists([]);
      } else {
        setTherapists(therapistResponse);
      }

      setTherapistOther([]);

    } catch (error) {
      console.error("Erreur lors du chargement des flypro:", error);
    }

  };

  const refreshAvailability = useCallback(async () => {
    if (realtimeRefreshInFlightRef.current) {
      return;
    }

    const now = Date.now();
    if (now - realtimeLastRefreshRef.current < 1500) {
      return;
    }

    realtimeLastRefreshRef.current = now;
    realtimeRefreshInFlightRef.current = true;

    try {
      const dateToUse = selectedDate ? new Date(selectedDate) : null;
      const hasValidDate = dateToUse && !isNaN(dateToUse.getTime());

      if (hasValidDate && selectedTime && latToUse != null && lngToUse != null) {
        await fetchTherapist(
          formatISODate(dateToUse),
          selectedTime,
          totalDuration,
          lngToUse,
          latToUse,
          zip_code,
          duo
        );
      } else if (hasValidDate) {
        await handleIfInvalidOrPastDate(dateToUse, null);
      }

      await refreshAvailableHours({ force: true });
      await refreshUnavailableDates({ force: true });
    } catch (error) {
      console.error("Realtime availability refresh failed:", error);
    } finally {
      realtimeRefreshInFlightRef.current = false;
    }
  }, [
    selectedDate,
    selectedTime,
    totalDuration,
    lngToUse,
    latToUse,
    zip_code,
    duo,
    fetchTherapist,
    handleIfInvalidOrPastDate,
    refreshAvailableHours,
    refreshUnavailableDates,
  ]);

  useEffect(() => {
    refreshAvailabilityRef.current = refreshAvailability;
  }, [refreshAvailability]);

  useEffect(() => {
    initPusher({ token: auth?.accessToken });

    const handler = (data) => {
      const payload =
        typeof data === "string"
          ? (() => {
            try {
              return JSON.parse(data);
            } catch (_) {
              return {};
            }
          })()
          : data || {};

      const key = payload?.key;
      if (key !== "availability" && key !== "calendar") {
        return;
      }

      refreshAvailabilityRef.current?.();
    };

    const unbind = bindEvent("public-data", "realtime.data.updated", handler);

    return () => {
      unbind();
    };
  }, [auth?.accessToken]);

  useEffect(() => {
    initPusher({ token: auth?.accessToken });
    const pusher = getPusher();
    if (!pusher) return;

    const handleConnected = () => {
      refreshAvailabilityRef.current?.();
    };

    pusher.connection.bind("connected", handleConnected);

    return () => {
      pusher.connection.unbind("connected", handleConnected);
    };
  }, [auth?.accessToken]);

  useEffect(() => {
    const handleOnline = () => {
      refreshAvailabilityRef.current?.();
    };

    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  const fetchTherapistWithRatings = async (therapistId) => {
    const res = await UserService.indexByRole(
      {
        id: therapistId,
        with: 'media,categories,ratings,ratings.creator.media',
      },
      'ROLE_FLYPRO',
      api,
      true
    );

    return Array.isArray(res) ? res[0] : res;
  };

  const openModal = () => setIsOpen(true);
  const openModal2 = async (therapist) => {
    unavailableDatesRequestRef.current += 1;
    setUnavailableDates([]);
    setAvailableHours({});
    setSelectedDate(null);
    setSelectedTime(null);
    setCurrentTherapist(therapist);
    setIsOpen2(true);
    setIsFirstOpen2(true);
    try {
      const full = await fetchTherapistWithRatings(therapist.id);
      if (full) setCurrentTherapist(full);
    } catch (e) {
      console.error("Failed to load therapist ratings:", e);
    }
  };

  const closeModal = () => setIsOpen(false);
  const closeModal2 = () => {
    setIsOpen2(false);
    setSelectedTherapist([{ id: 0 }]);

    if (previousSelection.date) {
      setSelectedDate(previousSelection.date);
    }
    if (previousSelection.time) {
      setSelectedTime(previousSelection.time);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (selectedDate && selectedTime && modalIsOpen2 && currentTherapist) {
      setSelectedTherapist([currentTherapist]);
    }

    const isEditingSequential = sessionStorage.getItem("editingSequential") === "true";

    if (isEditingSequential) {
      // For sequential bookings, only allow 1 therapist
      if (selectedTherapist.length !== 1) {
        return notify.warn(t('please_select_a_flypro'));
      }

      const chosen = selectedTherapist;
      const existing = JSON.parse(
        sessionStorage.getItem("newBooking") || "{}"
      );
      const dateISO = formatISODate(selectedDate);
      const startBefore = `${dateISO} ${selectedTime}`;

      const updatedBooking = {
        ...existing,
        address,
        hotel,
        hotelId,
        hotel_id: hotelId,
        therapists: chosen, // Only 1 therapist
        date: dateISO,
        time: selectedTime,
        start_before: startBefore,
        duo: false, // Sequential is not DUO
      };

      if (isEditMode) {
        sessionStorage.setItem("newBooking", JSON.stringify(updatedBooking));
        sessionStorage.setItem("editBookingMode", "true");
        navigate("/hotel-payment", {
          state: { fromEditBooking: true, ...updatedBooking }
        });
      } else {
        navigate("/hotel-payment");
      }
      return;
    }

    // Original DUO logic
    let therapistBlocked = false;
    const chosen =
      selectedTherapist[0]?.id === 0
        ? duo
          ? therapists.slice(0, 2)
          : therapists.slice(0, 1)
        : selectedTherapist;

    if (duo && chosen.length !== 2) {
      return notify.warn(t('please_select_two_flypros_for_duo'));
    }
    if (!duo && chosen.length !== 1) {
      return notify.warn(t('please_select_a_flypro'));
    }

    const existing = JSON.parse(
      sessionStorage.getItem("newBooking") || "{}"
    );

    const isEditMode = sessionStorage.getItem("editBookingMode") === "true";

    const dateISO = formatISODate(selectedDate);
    const startBefore = `${dateISO} ${selectedTime}`;

    await fetchTherapist(formatISODate(selectedDate), selectedTime, totalDuration, lngToUse, latToUse, zip_code);
    const therapistIds = new Set(therapists.map(o => o.id));
    const selectedTherapistIds = selectedTherapist.map(o => o.id);

    if (selectedTherapist[0]?.id !== 0) {

      if (!selectedTherapistIds.every(id =>
        therapistIds.has(id))) {
        openModalPaiement(`Le flypro que vous avez choisi n’est malheureusement plus disponible pour ce créneau. Nous vous invitons à revenir en arrière et à choisir un autre créneau ou un autre flypro pour que votre soin se déroule dans les meilleures conditions. Merci de votre compréhension.`);
        therapistBlocked = true;
        if (!selectedTherapistIds.every(id => therapistIds.has(id))) {
          openModalPaiement(`Le flypro que vous avez choisi n’est malheureusement plus disponible pour ce créneau. Nous vous invitons à revenir en arrière et à choisir un autre créneau ou un autre flypro pour que votre soin se déroule dans les meilleures conditions. Merci de votre compréhension.`);
          therapistBlocked = true;
        }
      } else if (therapists.length === 0) {
        openModalPaiement(`Le flypro que vous avez choisi n’est malheureusement plus disponible pour ce créneau. Nous vous invitons à revenir en arrière et à choisir un autre créneau ou un autre flypro pour que votre soin se déroule dans les meilleures conditions. Merci de votre compréhension.`);
        therapistBlocked = true;
      }
    }

    if (therapistBlocked) {
      console.warn(t('unavailable_therapist'));
      return;
    }

    const updatedBooking = {
      ...existing,
      address,
      hotel,
      hotelId,
      hotel_id: hotelId,
      therapists: chosen,
      date: dateISO,
      time: selectedTime,
      start_before: startBefore,
    };



    sessionStorage.setItem("newBooking", JSON.stringify(updatedBooking));

    const paymentState = {
      address,
      hotel,
      hotelId,
      hotel_id: hotelId,
      duo,
      totalDuration,
      totalPrice,
      selectedServices,
      selectedDate: formatISODate(selectedDate),
      selectedTime
    };

    const prevState = JSON.parse(sessionStorage.getItem('state') || '{}');
    sessionStorage.setItem('state', JSON.stringify({ ...prevState, ...paymentState }));
    if (isEditMode) {
      sessionStorage.setItem("editBookingMode", "true");
      navigate("/hotel-payment", {
        state: { fromEditBooking: true, ...updatedBooking }
      });
    } else {
      sessionStorage.removeItem("editBookingMode");
      navigate("/hotel-payment", {
        state: { ...updatedBooking }
      });
    }
  };


  const handleSubmitFilter = (event) => {
    event.preventDefault();
    setFilter(formData);
    setTimeout(async () => {
      handleHourClick(selectedTime);
      if (selectedDate && selectedTime) {
        await fetchTherapist(
          formatISODate(selectedDate),
          selectedTime,
          totalDuration,
          lng,
          lat,
          zip_code
        );
      }
    }, 1000);

    closeModal();
  };


  const handleMonthChange = (direction) => {
    const now = Date.now();
    if (window.lastMonthChange && (now - window.lastMonthChange) < 300) return;
    window.lastMonthChange = now;

    const currentDate = selectedDate || selectedDateScroll;
    if (!currentDate || isNaN(currentDate.getTime())) {
      console.error('Invalid date in handleMonthChange');
      return;
    }

    const maxVisibleMonths = 2;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const firstAllowedMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastAllowedMonth = new Date(today.getFullYear(), today.getMonth() + maxVisibleMonths, 1);

    const newDate = new Date(currentDate);
    newDate.setDate(1);
    newDate.setMonth(newDate.getMonth() + direction);
    newDate.setHours(0, 0, 0, 0);

    // Prevent going before current month or past last allowed month
    if (newDate < firstAllowedMonth) return;
    if (newDate > lastAllowedMonth) return;
    if (newDate.getFullYear() === today.getFullYear() && newDate.getMonth() === today.getMonth()) {
      newDate.setDate(today.getDate());
    } else {
      newDate.setDate(1);
    }


    const lastAllowedDate = new Date(today.getFullYear(), today.getMonth() + maxVisibleMonths + 1, 0);
    if (newDate > lastAllowedDate) newDate.setTime(lastAllowedDate.getTime());

    if (selectedDate) setSelectedDate(newDate);
    setSelectedDateScroll(newDate);
    updateDaysToShow(newDate);
    setSelectedTherapist([{ id: 0 }]);
  };

  const handleDayChange = (direction) => {
    const now = Date.now();
    if (window.lastDayChange && (now - window.lastDayChange) < 200) return;
    window.lastDayChange = now;

    const currentDate = selectedDate || selectedDateScroll;
    if (!currentDate || isNaN(currentDate.getTime())) {
      console.error('Invalid date in handleDayChange');
      return;
    }

    const container = document.querySelector('.row-date');
    if (!container) return;

    const dayElement = container.querySelector('.btn-day');
    const dayWidth = dayElement ? (dayElement.offsetWidth || 0) : 0;
    const containerWidth = container.clientWidth || 0;
    let visibleItems = 1;
    if (dayWidth > 0) {
      visibleItems = Math.max(1, Math.floor(containerWidth / dayWidth));
    }
    const daysToScroll = Math.max(1, Math.floor(visibleItems - 0.5));
    const maxVisibleMonths = 2;
    const windowSize = 9;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const endExclusive = new Date(today.getFullYear(), today.getMonth() + maxVisibleMonths + 1, 1);
    const allDays = [];
    let cur = new Date(today);
    while (cur < endExclusive) {
      allDays.push(new Date(cur.getFullYear(), cur.getMonth(), cur.getDate()));
      cur.setDate(cur.getDate() + 1);
    }
    const firstVisible = daysToShow && daysToShow.length ? daysToShow[0] : (selectedDate || today);
    let currentStartIndex = allDays.findIndex(d => d.getTime() === new Date(firstVisible.getFullYear(), firstVisible.getMonth(), firstVisible.getDate()).getTime());
    if (currentStartIndex === -1) currentStartIndex = Math.max(0, allDays.length - windowSize);

    const maxStart = Math.max(0, allDays.length - windowSize);
    let newStart = currentStartIndex + direction * daysToScroll;
    if (newStart < 0) newStart = 0;
    if (newStart > maxStart) newStart = maxStart;

    const newWindow = allDays.slice(newStart, newStart + windowSize);
    setDaysToShow(newWindow);
    const newSelected = newWindow.length ? newWindow[0] : (allDays[allDays.length - 1] || today);
    if (selectedDate) setSelectedDate(newSelected);
    setSelectedDateScroll(newSelected);
    setSelectedTime(null);
    setTherapists('');
    setSelectedTherapist([{ id: 0 }]);
  };
  const redirectToPartnerHotels = () => {
    window.location.href = '/hotels';
  };

  function handleDayClick(date) {
    setSelectedDate(date);
    setSelectedTime(null)
    setSelectedTherapist([{ id: 0 }]);
    setTherapists('')
    const now = new Date();
    let initialTime;
    // if (date.getDay() === 0) {
    //   setShowPopup(true);
    // }


    if (selectedTime === null)
      return;

    if (date?.toDateString() === now?.toDateString()) {
      const nextQuarterHour = Math.ceil(now.getMinutes() / 15) * 15;
      now.setMinutes(nextQuarterHour);
      now.setSeconds(0);

      initialTime = now;
    } else {
      initialTime = new Date(date);
      initialTime.setHours(8, 0, 0, 0);
    }

    //setSelectedTime(initialTime.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }));
    //fetchTherapist(formatISODate(date), selectedTime, totalDuration, lat, lng, zip_code);
  }


  function handleHourClick(hour) {
    let dateToUse = selectedDate;

    if (!selectedDate) {
      dateToUse = new Date();
      setSelectedDate(dateToUse);
    }
    setSelectedTime(hour);
    if (selectedDate && modalIsOpen2 && currentTherapist) {
      setSelectedTherapist([currentTherapist]);
    } else {
      setSelectedTherapist([{ id: 0 }]);
    }
    if (latToUse != null && lngToUse != null) {
      // fetchTherapist(formatISODate(dateToUse), hour, totalDuration, lngToUse, latToUse, zip_code);
    }
  }



  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === "checkbox"
        ? prevState[name] === value
          ? "" // Uncheck si déjà sélectionné
          : value
        : value,
    }));
  };

  /*const handleResetFilter = () => {

    setFormData({
      tags: "",
      is_asca: "",
      is_rme: "",
      civility: "",
    })

  }*/

  const handleResetFilter = async () => {
    const hasActiveFilters =
      formData.tags ||
      formData.is_asca ||
      formData.is_rme ||
      formData.civility;

    if (!hasActiveFilters) {
      return;
    }

    const resetFormData = {
      tags: "",
      is_asca: "",
      is_rme: "",
      civility: "",
      status: "ACTIVE"
    };

    const resetFilters = {
      with: 'primary_address,zones,media,categories,slots',
      sort: 'firstname'
    };

    setFormData(resetFormData);
    setFilters(resetFilters);
    setFilter(null);

    try {
      const date = formatISODate(selectedDate);
      const time = selectedTime;
      const duration = totalDuration;
      const zipCode = zip_code;
      const products = selectedServices.map(s => s?.product?.id).filter(Boolean);
      const isEditMode = sessionStorage.getItem("editBookingMode") === "true";
      const booking = JSON.parse(sessionStorage.getItem("newBooking"));
      const oldBooking = JSON.parse(sessionStorage.getItem("oldBooking"));
      const therapistResponse = await TherapistService.store(
        isEditMode ? {
          date,
          time,
          duration: totalDuration,
          lng: lngToUse,
          lat: latToUse,
          zip_code: zipCode,
          products,
          is_duo: duo,
          status: "ACTIVE",
          categories: selectedCategoryIds,
          booking_id: booking?.id ?? oldBooking?.id ?? 0
        } : {
          date,
          time,
          duration: totalDuration,
          lng: lngToUse,
          lat: latToUse,
          zip_code: zipCode,
          products,
          is_duo: duo,
          status: "ACTIVE",
          categories: selectedCategoryIds,
        },
        api,
        {
          with: `media,categories`,
          ...resetFormData
        }
        , auth?.accessToken ? false : true
      );

      // Use cached therapists list instead of fetching again
      const allTherapists = allTherapistsList.length > 0 ? allTherapistsList : [];

      let processedTherapists = therapistResponse;
      if (duo) {
        const flattened = [].concat(...Object.values(therapistResponse));
        processedTherapists = Array.from(
          new Map(flattened.map(t => [t.id, t])).values()
        );
      }

      setTherapists(processedTherapists);

      const therapistIds = new Set(processedTherapists.map(t => t.id));
      const filteredTherapists = zipCode
        ? allTherapists.filter(therapist =>
          !therapistIds.has(therapist.id) &&
          therapist.zones?.some(zone => {
            return isZipInZone(zip_code, zone);
          })
        )
        : allTherapists;

      setTherapistOther(filteredTherapists);

    } catch (error) {
      console.error("Error in reset filter API call:", error);
    }
  };

  const civilityLabels = {
    MS: "Femme",
    MR: "Homme",
  };

  const [tagsLabels, setTagsLabels] = useState({});

  useEffect(() => {
    setTagsLabels({
      "contains:french": t('hotel:french'),
      "contains:english": t('hotel:english'),
      "contains:german": t('hotel:german'),
      "contains:italian": t('hotel:italian'),
      "contains:spanish": t('hotel:spanish'),
      "contains:arabic": t('hotel:arabic'),
      "contains:portuguese": t('hotel:portuguese'),
      "contains:russian": t('hotel:russian')
    });
  }, [i18n.language]);

  const getFilterText = () => {
    let filters = [];


    if (formData.civility && civilityLabels[formData.civility]) {
      filters.push(civilityLabels[formData.civility]);
    }


    if (formData.tags && tagsLabels[formData.tags]) {
      filters.push(tagsLabels[formData.tags]);
    }


    if (formData.is_asca === "1") {
      filters.push("ASCA");
    }


    if (formData.is_rme === "1") {
      filters.push("RME");
    }
    return filters.length > 0 ? `Filter: ${filters.join(" - ")}` : "";
  };


  const getMonthName = (date) => {
    if (!date || isNaN(date.getTime())) {
      return new Date().toLocaleString(i18n.language, { month: 'long' }).charAt(0).toUpperCase() +
        new Date().toLocaleString(i18n.language, { month: 'long' }).slice(1);
    }
    const month = date.toLocaleString(i18n.language, { month: 'long' });
    return month.charAt(0).toUpperCase() + month.slice(1);
  };

  const getDayName = (date) => {
    if (!date || isNaN(date.getTime())) {
      return new Date().toLocaleString(i18n.language, { weekday: 'short' });
    }
    return date.toLocaleString(i18n.language, { weekday: 'short' });
  };

  const getNextHourSlots = (date) => {
    const now = new Date();
    const hours = [];

    if (date?.toDateString() === now?.toDateString()) {
      const minutes = now.getMinutes();
      const nextQuarterHour = Math.ceil(minutes / 15) * 15;
      now.setMinutes(nextQuarterHour);
      now.setSeconds(0);

      for (let i = 0; i < 57; i++) {
        const slot = new Date(now.getTime() + i * 15 * 60000);
        if (slot.getHours() >= 8 && slot.getHours() < 22) {
          hours.push(slot.toLocaleTimeString('en-CA', { timeZone: 'Europe/Zurich', hour: '2-digit', minute: '2-digit', hour12: false }));
        }
      }
    } else {
      const startOfDay = new Date(date);
      startOfDay.setHours(8, 0, 0, 0);

      for (let i = 0; i < 57; i++) {
        const slot = new Date(startOfDay.getTime() + i * 15 * 60000);
        if (slot.getHours() >= 8 && slot.getHours() < 22) {
          hours.push(slot.toLocaleTimeString('en-CA', { timeZone: 'Europe/Zurich', hour: '2-digit', minute: '2-digit', hour12: false }));
        }
      }
    }

    return hours;
  };

  const scrollLeft = () => {
    const container = document.querySelector('.row-day');
    if (!container) return;

    const dayWidth = container.querySelector('.btn-hour')?.offsetWidth || 0;
    const visibleItems = Math.floor(container.clientWidth / dayWidth);
    const scrollDistance = dayWidth * (visibleItems - 0.5);

    container.scrollBy({ left: -scrollDistance, behavior: 'smooth' });
  };

  const scrollRight = () => {
    const container = document.querySelector('.row-day');
    if (!container) return;

    const dayWidth = container.querySelector('.btn-hour')?.offsetWidth || 0;
    const visibleItems = Math.floor(container.clientWidth / dayWidth);
    const scrollDistance = dayWidth * (visibleItems - 0.5);

    container.scrollBy({ left: scrollDistance, behavior: 'smooth' });
  };


  //const hours = getNextHourSlots(selectedDate);
  // sessionStorage.removeItem("previousPath");

  return (
    <>
      <MenuHeader />
      <NavHotel page="therapist" />
      <div className={`container ${!modalIsOpen2 && 'container-therapeut'}`}>
        {!modalIsOpen2 && <h2 style={{ textAlign: 'center', fontWeight: 700, color: '#000000' }}>{t('choisir')}</h2>}
      </div>
      <form className="form-masseur booking-therapist-page booking-therapist-page--hotel" onSubmit={handleSubmit}>
        {modalIsOpen2 ? <>
          <div className="contentModal">

            <HeaderTherapist currentTherapist={currentTherapist} closeModal2={closeModal2} />
            <form className="form-masseur" onSubmit={handleSubmit}>
              <DateTimeSelector selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                selectedTime={selectedTime}
                modalIsOpen2={modalIsOpen2}
                setSelectedTime={setSelectedTime}
                handleMonthChange={handleMonthChange}
                selectedDateScroll={selectedDateScroll}
                handleDayChange={handleDayChange}
                handleDayClick={handleDayClick}
                handleHourClick={handleHourClick}
                daysToShow={daysToShow}
                hours={hours}
                totalPrice={totalPrice}
                scrollLeft={scrollLeft}
                scrollRight={scrollRight}
                openModal={openModal}
                getMonthName={getMonthName}
                getDayName={getDayName}
                getFilterText={getFilterText()}
                handleResetFilter={handleResetFilter}
                unavailableDates={unavailableDates}
                availableHours={availableHours}
                buffertime={buffertime}
                totalDuration={totalDuration}
                isHotel={true}
                currentTherapist={currentTherapist}
              />

            </form>
            <ReviewList currentTherapist={currentTherapist} />
            <Informations currentTherapist={currentTherapist} filter={hotelId} axios={api} auth={auth} />
          </div></> : <>
          <div className={`container ${!modalIsOpen2 && 'container-therapeut'}`}>
            <DateTimeSelector
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              selectedTime={selectedTime}
              setSelectedTime={setSelectedTime}
              handleMonthChange={handleMonthChange}
              selectedDateScroll={selectedDateScroll}
              handleDayChange={handleDayChange}
              handleDayClick={handleDayClick}
              handleHourClick={handleHourClick}
              daysToShow={daysToShow}
              hours={hours}
              totalPrice={totalPrice}
              scrollLeft={scrollLeft}
              scrollRight={scrollRight}
              openModal={openModal}
              getMonthName={getMonthName}
              getDayName={getDayName}
              getFilterText={getFilterText()}
              unavailableDates={unavailableDates}
              availableHours={availableHours}
              buffertime={buffertime}
              totalDuration={totalDuration}
              handleResetFilter={handleResetFilter}
              isHotel={true}
            />
            <p className="therapist-selection-guidance">{t('therapist:select_therapist_zone')}</p>
            <div className="form-group group-masseur">
              {therapists.length > 0 && selectedDate && selectedTime &&
                <div className="therapist-item" onClick={() => { addedTherapist({ id: 0 }); }}>
                  <div className="therapist-info">
                    <p className="name" style={{ paddingLeft: "30px", fontWeight: "bold" }}>{t('hotel:preference')} </p>
                    <button
                      type="button"
                      className={`btn-outline-primary default ${selectedTherapist.some(t => t.id === 0) ? 'selected' : ''}`}
                    >
                      &gt;
                    </button>
                  </div>
                </div>
              }
              {therapists.length > 0 && therapists?.map((therapist) => (
                <div
                  key={therapist.id}
                  className={`therapist-item ${!selectedTime ? 'therapist-item--awaiting-time' : ''}`}
                  onClick={() => {
                    if (!selectedDate || !selectedTime) {
                      openModal2(therapist);
                      return;
                    }
                    addedTherapist(therapist);
                  }}
                >
                  <img
                    src={therapist.media?.length ? therapist.media[0].original_url : user}
                    alt={therapist?.name}
                    className="therapist-image"
                  />
                  <div className="therapist-info">
                    <p className="name">
                      <span className="flypro-card-meta__name-text">{therapist?.firstname}</span>
                      <Tooltip title={t('therapists_info')} placement="top" arrow slotProps={{
                        popper: {
                          sx: {
                            '& .MuiTooltip-tooltip': {
                              backgroundColor: '#393d44',
                              color: '#fff',
                              fontSize: '1rem',
                              padding: '8px 12px',
                              borderRadius: '8px'
                            },
                            '& .MuiTooltip-arrow': {
                              color: '#393d44',
                            }
                          }
                        }
                      }}>
                        <IconButton
                          onClick={(e) => {
                            e.stopPropagation();
                            openModal2(therapist);
                          }}
                        >
                          <InfoIcon />
                        </IconButton>
                      </Tooltip>
                    </p>
                    <FlyproCardMetadata therapist={therapist} />
                    {selectedTherapist.some(t => t.id === therapist.id) && (
                      <span className="therapist-selection-indicator" aria-hidden="true" />
                    )}
                  </div>
                </div>
              ))}

            </div>
            {/* {therapistsOther.length > 0 && !duo && (
              <>
                <div className='other'>{t('hotel:disponible')}</div>
                <div className="form-group group-masseur">

                  {therapistsOther?.map((therapist) => (
                    <div key={therapist.id} className="therapist-item" onClick={() => addedTherapist(therapist)}>
                      <img onClick={() => openModal2(therapist)} src={therapist.media.length ? therapist.media[0].original_url : user} alt={therapist?.name} className="therapist-image" />
                      <div className="therapist-info">
                        <p className="name">{therapist?.firstname}</p>
                        <p className="note">{therapist.extra?.rating ? (Number.isInteger(therapist.extra.rating) ? therapist.extra.rating : therapist.extra.rating.toFixed(1)) : "5"}/5</p>
                        <button
                          type="button"
                          className={`btn-outline-primary ${selectedTherapist.some(t => t.id === therapist.id) ? 'selected' : ''}`}
                        >
                          &gt;
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )} */}
          </div>

        </>}

        <div className='btn-bottom'>
          <button type="submit" className="btn btn-primary" disabled={!selectedTime || (modalIsOpen2 && duo)}>
            {t('hotel:next')}
          </button>
        </div>

      </form >
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <p>{t('hotel:no_service_sunday')}</p>
            <button onClick={redirectToPartnerHotels} className="btn redirect-button">
              {t('hotel:choose_partner_hotel')}
            </button>
            <button onClick={() => setShowPopup(false)} className="btn close-button">
              {t('hotel:close')}
            </button>
          </div>
        </div>
      )
      }


      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="contentModal">
          <div className="headerModal modal-icone">
            <a onClick={closeModal}>
              <img src={back} alt="Fermer" />
            </a>
            <a onClick={closeModal}>
              <img src={croix} alt="Fermer" />
            </a>
          </div>
          <div className="form-inscription">
            <form onSubmit={handleSubmitFilter}>

              <div className="form-choix">
                <div className="form-radio">
                  <input
                    type="checkbox"
                    name="civility"
                    value="MR"
                    checked={formData.civility === "MR"}
                    id="monsieur"
                    onChange={handleChange}
                  />
                  <label htmlFor="monsieur">{t('hotel:male')}</label>
                </div>
                <div className="form-radio">
                  <input
                    type="checkbox"
                    name="civility"
                    value="MS"
                    id="madame"
                    checked={formData.civility === "MS"}
                    onChange={handleChange}
                  />
                  <label htmlFor="madame">{t('hotel:female')}</label>
                </div>
              </div>
              <div className='flex-row gap-10'>
                <div className="form-text">
                  <label>{t('hotel:language')}</label>
                  <select
                    value={formData.tags || ""}
                    name="tags"
                    onChange={handleChange}
                  >
                    <option value="">{t('hotel:select_language')}</option>
                    <option value="contains:french">{t('hotel:french')}</option>
                    <option value="contains:english">{t('hotel:english')}</option>
                    <option value="contains:german">{t('hotel:german')}</option>
                    <option value="contains:italian">{t('hotel:italian')}</option>
                    <option value="contains:spanish">{t('hotel:spanish')}</option>
                    <option value="contains:arabic">{t('hotel:arabic')}</option>
                    <option value="contains:portuguese">{t('hotel:portuguese')}</option>
                    <option value="contains:russian">{t('hotel:russian')}</option>
                  </select>
                </div>
              </div>
              <div className="form-choix">
                <div className="form-radio">
                  <input
                    type="checkbox"
                    name="is_asca"
                    value="1"
                    id="is_asca"
                    checked={formData.is_asca === "1"}
                    onChange={handleChange}
                  />
                  <label htmlFor="is_asca">ASCA</label>
                </div>
                <div className="form-radio">
                  <input
                    type="checkbox"
                    name="is_rme"
                    value="1"
                    id="is_rme"
                    checked={formData.is_rme === "1"}
                    onChange={handleChange}
                  />
                  <label htmlFor="is_rme">RME</label>
                </div>
              </div>

              <div className="form-button">
                <button className='btn-submit' type="submit">{t('hotel:filter')}</button>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={modalIsPaiementOpen}
        onRequestClose={closeModalPaiement}
        style={customStyles2}
        contentLabel="Paiement Modal"
        id="custom-popup-content"
      >
        <div className="contentModal">
          <div className="modal">
            <p className="modal-text2 text-message" style={{ whiteSpace: 'pre-line' }}>
              {modalMessage}
            </p>
            <div className="modal-button-container">
              <button className="modal-ok-button" onClick={redirectToHome}>
                OK
              </button>
              <button className="modal-cancel-button" onClick={closeModalPaiement}>
                Annuler
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}
export default ChooseHotelTherapist;
